export default {
	baseUrl: '/api',
	timeout: '30000',
	anonymousUser: 'anonymous',
	anonymousPass: 'anonymous',
	clientName: 'tickets',
	sessionLSKey: 'fvt_session',
	workinRoleLSKey: 'fvt_working_role'
};
